module.exports = __webpack_public_path__ + "gg.svg?49214809e2a8b472548bc9cc08d5d97d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gg.svg
// module id = 1256
// module chunks = 27